import { Box, Button, Stack, Typography } from '@mui/material';
import { TEST_IDS } from 'src/test-ids';
import { InfiniteCanvasTemplateDropDown } from 'src/pages/project/overview';

interface CanvasTemplateSelectorProps {
  templateId: string;
  canvasCreated: boolean;
  isCreating: boolean;
  isSubmitting: boolean;
  canCreateCanvas: boolean;
  onTemplateChange: (templateId: string) => void;
  onCreateCanvas: () => void;
}

export const CanvasTemplateSelector = ({
  templateId,
  canvasCreated,
  isCreating,
  isSubmitting,
  canCreateCanvas,
  onTemplateChange,
  onCreateCanvas,
}: CanvasTemplateSelectorProps) => {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle2" color="text.secondary">
        Configure new canvas:
      </Typography>

      <InfiniteCanvasTemplateDropDown
        value={templateId}
        onChange={(e) => onTemplateChange(e.target.value)}
        disabled={isSubmitting || isCreating || canvasCreated}
      />

      {canCreateCanvas && (
        <Button
          variant="contained"
          onClick={onCreateCanvas}
          disabled={isSubmitting || isCreating}
          fullWidth
          data-testid={TEST_IDS.CANVAS_FIELD.CONFIGURE_BUTTON}
        >
          Configure Canvas
        </Button>
      )}

      {canvasCreated && (
        <Box sx={{ p: 2, bgcolor: 'success.lighter', borderRadius: 1 }}>
          <Typography color="success.main" variant="body2">
            ✓ Canvas configured successfully
          </Typography>
        </Box>
      )}
    </Stack>
  );
};
